module.exports = __webpack_public_path__ + "static/media/lock_icon.e8cd9e22.svg";